// extracted by mini-css-extract-plugin
module.exports = {"root":"App-root-b8d425fe9d14704a446f67763f1450eb","tabContent":"App-tabContent-c53cbfdfbe30e99da5086b03ed029a6b"};